import { VideoType } from '@d-id/types';

export const getAgentBgObject = (presenterType: VideoType, color: string | undefined, source_url: string | undefined) => {
    if (!color && !source_url) return {};

    if (presenterType === VideoType.CLIP) {
        return {
            background: {
                source_url: source_url || undefined,
                color: color || undefined,
            },
        };
    }

    if (presenterType === VideoType.TALK) {
        return {
            source_url: source_url!,
        };
    }

    return {};
};
